import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _1_45double_45slash_45global from "/app/middleware/1.doubleSlash.global.ts";
import auth_45guard_45global from "/app/middleware/authGuard.global.ts";
import mur_45id_45global from "/app/middleware/mur-id.global.ts";
import page_45type_45global from "/app/middleware/pageType.global.ts";
import redirect_45trailing_45slash_45global from "/app/middleware/redirectTrailingSlash.global.ts";
import route_45change_45tracking_45observer_45global from "/app/middleware/routeChangeTrackingObserver.global.ts";
import scope_45global from "/app/middleware/scope.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _1_45double_45slash_45global,
  auth_45guard_45global,
  mur_45id_45global,
  page_45type_45global,
  redirect_45trailing_45slash_45global,
  route_45change_45tracking_45observer_45global,
  scope_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "brand-content-page-type": () => import("/app/middleware/brand-content-page-type.ts")
}